import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { GallerySection } from '../components/GallerySection';
import { EmotionalLead } from '../components/EmotionalLead';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-273">
      <AnnouncementBar data-id="element-274" />
      <HeroSection data-id="element-275" />
      <GallerySection data-id="element-276" />
      <EmotionalLead data-id="element-277" />
      <UniqueMechanism data-id="element-278" />
      <BenefitsSection data-id="element-279" />
      <TestimonialsSection data-id="element-280" />
      <OfferSection data-id="element-281" />
      <GuaranteeSection data-id="element-282" />
      <UrgencySection data-id="element-283" />
      <FAQSection data-id="element-284" />
      <EmotionalClose data-id="element-285" />
      <Footer data-id="element-286" />
    </div>;
}